import { useEffect } from "react";

import { pm2ConfigStore } from "@pm2/store";
import { useUserIdentityState } from "@provider/user-identity";

let hasInitializedHotjar = false;

/**
 * setup Hotjar analytics / tracking script
 *
 * lazy load the actual script so it doesn't interfere with initial site
 * rendering performance
 */
export function useHotjar(): void {
  const hotjarId = pm2ConfigStore.useSelector(
    (state) => state.config.settings.hotjarID,
  );
  const user = useUserIdentityState((state) => state.user);

  useEffect(() => {
    if (!hotjarId || !user) {
      return;
    }

    if (hasInitializedHotjar) {
      // due to the way that Hotjar has been implemented, we cannot ever
      // run initialization more than once
      return;
    }

    hasInitializedHotjar = true;

    // load the Sleeknote script
    const hotjarScriptTag = document.createElement("script");

    hotjarScriptTag.type = "text/javascript";
    hotjarScriptTag.appendChild(
      document.createTextNode(`
      (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:${JSON.stringify(hotjarId)},hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`),
    );

    document.head.appendChild(hotjarScriptTag);
  }, [user, hotjarId]);
}
